import { render, staticRenderFns } from "./AppPhotoPreview.vue?vue&type=template&id=72dcd4ee&"
import script from "./AppPhotoPreview.vue?vue&type=script&lang=js&"
export * from "./AppPhotoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports